import React from 'react';
import { Divider } from 'material-ui';
import moment from 'moment';
import TwoColumnRow from '../../../tc-ui/two-column-row.jsx';
import RateTable from '../rate-tables/rate-table-template-container';
import { prettifyDays } from '../../contractingUtils';
import R from 'ramda';

const Table = props => {
  const {
    stayPays,
    daysOfWeek,
    isStayPay,
    allowCombination,
    offerName,
    bookingCode,
    validDatesOfSale,
    validDatesOfTravel,
    offerDetail,
    specialConditions,
    productType,
    rate,
    rates,
    rateType,
    nettCommission,
    commissionPercentage,
    nonStandardTemplateType,
    discountType,
    amount,
    style,
    contractState,
    openEditModal,
    contractingPeriod,
    withEditableRateTable,
    updateTableCell,
    offerIndex,
    classes={},
  } = props;
  const rateString = (() => {
    if (rate === 'discount') return `${discountType === 'percentage' ? `${amount}%` : `$${amount}`} off`;
  })();
  const getClass = (type) => {
    const className = R.keys(classes).find(str => str.indexOf(type) > -1);
    return classes[className];
  };
  const commission = commissionPercentage ? <span className={classes['commissionPercentage']}>{`COMMISSION: ${commissionPercentage}%\n`}</span> : '';
  const basedCommission = nettCommission ? <span className={classes['nettCommission']}>{`NETT RATE BASED ON ${nettCommission}% COMMISSION\n`}</span> : '';
  return (
    <div style={style} className={classes[`${offerIndex}-offer`] || ''}>
      <TwoColumnRow
        outerContainerStyle={{ marginBottom: '12px' }}
        leftColumnStyle={{ textAlign: 'left', whiteSpace: 'pre' }}
        leftColumnContent={
          <div>
            {'OFFER TITLE\n'}
            <b className={classes[`${offerIndex}-offerName`] || ''}>{offerName}</b>
          </div>
        }
        rightColumnStyle={{ textAlign: 'right', whiteSpace: 'pre' }}
        rightColumnContent={<span>
          {'BOOKING CODE\n'}
          <b className={classes[`${offerIndex}-bookingCode`] || ''}>{bookingCode}</b>
        </span>}
      />
      <Divider />
      <TwoColumnRow
        outerContainerStyle={{ marginTop: '6px', marginBottom: '6px', fontSize: '12px', padding: '0 4px' }}
        leftColumnStyle={{ textAlign: 'left', whiteSpace: 'pre' }}
        leftColumnContent="SALE DATES"
        rightColumnStyle={{ textAlign: 'right', whiteSpace: 'pre' }}
        rightColumnContent="TRAVEL DATES"
      />
      <TwoColumnRow
        outerContainerStyle={{ marginTop: '6px', marginBottom: '6px', padding: '0 4px' }}
        leftColumnStyle={{ textAlign: 'left', whiteSpace: 'pre', display: 'flex', flexDirection: 'column' }}
        leftColumnContent={
          validDatesOfSale.length || !R.isEmpty(classes) ? validDatesOfSale.map((validDate, dateIndex) => {
            const fromDateStr = moment.utc(new Date(validDate.fromDate)).format('DD MMM YYYY');
            const toDateStr = validDate.toDate ? moment.utc(new Date(validDate.toDate)).format('DD MMM YYYY') : fromDateStr;
            return fromDateStr === toDateStr ?
              <span key={`sale${dateIndex}`} className={classes[`${offerIndex}-validDatesOfSale-${dateIndex}-fromDate`]}>{fromDateStr}</span>
              : (<span key={`sale${dateIndex}`}>
                <span className={classes[`${offerIndex}-validDatesOfSale-${dateIndex}-fromDate`]}>{fromDateStr}</span> -
                <span className={classes[`${offerIndex}-validDatesOfSale-${dateIndex}-toDate`]}>{toDateStr}</span>
              </span>);
          }) : <span style={{ cursor: 'pointer', color: '#f44336' }} onClick={openEditModal}>Update Sale Dates</span>
        }
        rightColumnStyle={{ textAlign: 'right', whiteSpace: 'pre', display: 'flex', flexDirection: 'column' }}
        rightColumnContent={
          validDatesOfTravel.length || !R.isEmpty(classes) ? validDatesOfTravel.map((travelDate, dateIndex) => {
            const fromDateStr = moment.utc(new Date(travelDate.fromDate)).format('DD MMM YYYY');
            const toDateStr = travelDate.toDate ? moment.utc(new Date(travelDate.toDate)).format('DD MMM YYYY') : fromDateStr;
            return fromDateStr === toDateStr ?
              <span key={`travel${dateIndex}`} className={classes[`${offerIndex}-validDatesOfTravel-${dateIndex}-fromDate`]}>{fromDateStr}</span>
              : (<span key={`travel${dateIndex}`}>
                <span className={classes[`${offerIndex}-validDatesOfTravel-${dateIndex}-fromDate`]}>{fromDateStr}</span> -
                <span className={classes[`${offerIndex}-validDatesOfTravel-${dateIndex}-toDate`]}>{toDateStr}</span>
              </span>);
          }) : <span style={{ cursor: 'pointer', color: '#f44336' }} onClick={openEditModal}>Update Travel Dates</span>
        }
      />
      <Divider />
      {
        Boolean(rateString) && <div>
          <TwoColumnRow
            outerContainerStyle={{ marginTop: '6px', marginBottom: '6px', fontSize: '12px', padding: '0 4px' }}
            leftColumnStyle={{ textAlign: 'left', whiteSpace: 'pre' }}
            leftColumnContent="OFFER RATE"
            rightColumnStyle={{ textAlign: 'right', whiteSpace: 'pre', fontWeight: 'bold' }}
            rightColumnClassName={classes[`${offerIndex}-rate`] || classes[`${offerIndex}-discountType`] || classes[`${offerIndex}-amount`]}
            rightColumnContent={rateString}
          />
          <Divider />
        </div>
      }
      {
        isStayPay ? (<div style={{ marginTop: '12px', fontWeight: 'bold', padding: '0 0 12px 4px', display: 'flex', justifyContent: 'space-between', clear: 'both' }}>
          <div className={getClass(`${offerIndex}-daysOfWeek`)}>
            {prettifyDays(daysOfWeek)}
          </div>
          <div className={getClass(`${offerIndex}-stayPays`)}>
            {
              stayPays.map((sp, i) => (<div key={i}>{`Stay ${sp.stayDays} Pay ${sp.payDays}${sp.maxFOC ? `, Max ${sp.maxFOC} FOC Nights Allowed` : ''}`}</div>))
            }
          </div>
        </div>) : <div/>
      }
      {
        rate === 'rateAmount' ? <Divider style={{ marginBottom: '12px' }} /> : <span/>
      }
      {
        rate === 'rateAmount' && (
          <div>
            {rateType === 'includeCommission' ? commission : basedCommission}
            <RateTable
              productType={productType}
              classes={classes[`${offerIndex}-ratesClasses`]}
              withEditableCell={withEditableRateTable}
              updateTableCell={updateTableCell}
              contractState={contractState}
              rateSet={{ rates, nonStandardTemplateType }}
              forOffer
              showHeader
            />
          </div>)
      }
      <Divider />
      <div style={{ display: offerDetail ? 'block' : 'none', marginTop: '12px', paddingLeft: '4px', whiteSpace: 'pre-line', clear: 'both' }}>
        <label style={{ fontSize: '12px' }}>OFFER DETAILS: </label>
        <br/>
        <span className={classes[`${offerIndex}-offerDetail-textblock`] ? '' : classes[`${offerIndex}-offerDetail`]}>
          {classes[`${offerIndex}-offerDetail-textblock`] || offerDetail}
        </span>
      </div>
      {
        Boolean(specialConditions) && (
          <div style={{ marginTop: '12px', paddingLeft: '4px', whiteSpace: 'pre-line' }}>
            <label style={{ fontSize: '12px' }}>SPECIAL CONDITIONS: </label>
            <br/>
            <span className={classes[`${offerIndex}-specialConditions-textblock`] ? '' : classes[`${offerIndex}-specialConditions`]} >
              {classes[`${offerIndex}-specialConditions-textblock`] || specialConditions}
            </span>
          </div>
        )
      }
      <div
        style={{ marginTop: '12px', paddingLeft: '4px', color: 'rgba(0, 0, 0, 0.74)' }}
      >
        This special offer <span className={classes[`${offerIndex}-allowCombination`]}>{allowCombination ? 'IS ' : 'IS NOT '}</span>combinable with other offers.
      </div>
    </div>
  );
};

export default Table;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/special-offer-tables/table.jsx